import React, { useState, useEffect } from "react";

function diff(target) {
  const now = new Date().getTime();
  const end = new Date(target).getTime();
  let d = Math.max(0, Math.floor((end - now) / 1000));
  const days = Math.floor(d / 86400); d -= days * 86400;
  const hours = Math.floor(d / 3600); d -= hours * 3600;
  const mins = Math.floor(d / 60); const secs = d - mins * 60;
  return { days, hours, mins, secs, ended: end - now <= 0 };
}

function Cell({ value, label }) {
  return (
    <div className="flex flex-col items-center">
      <div className="bg-neutral-900 text-white font-display font-bold text-xl sm:text-2xl rounded-xl w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center tabular-nums">
        {String(value).padStart(2, "0")}
      </div>
      <span className="text-[10px] uppercase tracking-wider text-neutral-500 mt-1">{label}</span>
    </div>
  );
}

export default function CountdownTimer({ target, testId = "countdown" }) {
  const [t, setT] = useState(() => diff(target));
  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) return <span className="text-neutral-400 text-sm">Sin fecha definida</span>;
  if (t.ended) return <span className="text-red-600 font-semibold" data-testid={`${testId}-ended`}>Ventas cerradas</span>;

  return (
    <div className="flex gap-2 sm:gap-3" data-testid={testId}>
      <Cell value={t.days} label="Días" />
      <Cell value={t.hours} label="Horas" />
      <Cell value={t.mins} label="Min" />
      <Cell value={t.secs} label="Seg" />
    </div>
  );
}
